import type { ZodTypeAny } from 'zod';
import { z } from 'zod';

import type { FieldDescriptor } from '../../types/common';

import { SelectModalFieldElement } from './SelectModalField';
import type { SelectModalField as SelectModalFieldType } from './types';

const createValidationSchema = (field: SelectModalFieldType) => {
  let fieldSchema: ZodTypeAny = z.union([z.string(), z.number(), z.boolean()], {
    required_error: 'Please select an option',
  });
  if (field.validation?.isOptional) {
    fieldSchema = fieldSchema.optional();
  }

  return fieldSchema;
};

const Descriptor: FieldDescriptor<SelectModalFieldType> = {
  FieldComponent: SelectModalFieldElement,
  name: 'SelectModalField',
  createValidationSchema,
};

export default Descriptor;

export type { SelectModalFieldType };
